<template>
  <navigation-layout ref='navigationlayout'>
    <h1 slot="title">{{title}}</h1>
    <h3 slot="abstract">{{abstract}}</h3>
    <main>
      <md-button class="md-raised md-primary" :disabled="loading" @click="exportData()">Csv Export</md-button>
      <div class="md-layout" id='integratorlist'>
        <div class="md-layout-item md-size-100" v-for="(integratorFacility, index) in integratorsWithFacilitiesData" :key="index">
           <md-list style="width:100%">
          <md-list-item md-expand v-if="integratorFacility.facilities.length > 0">
          <md-icon>build</md-icon>
          <span class="md-list-item-text">{{integratorFacility.integratorData.id}} - {{integratorFacility.integratorData.name}}</span>
          <md-badge class="md-primary" :md-content="integratorFacility.facilities.length" />
          <md-list slot="md-expand" style="width:100%">
        <md-list-item class="md-inset">
          <md-icon></md-icon>
        <div class="md-layout">
        <div class="md-layout-item md-size-25 md-medium-size-50 md-small-size-100">
        <span class="md-list-item-text md-title">Company name</span></div>
        <div class="md-layout-item md-size-25 md-medium-size-50 md-small-size-100">
        <span class="md-list-item-text md-title">Url</span></div>
        <div class="md-layout-item md-size-30 md-medium-size-50 md-small-size-100">
        <span class="md-list-item-text md-title">Integration api key</span></div>
        <div class="md-layout-item md-size-20 md-medium-size-50 md-small-size-100">
        <span class="md-list-item-text md-title">Country name</span></div>
        <md-divider style="width:100%"></md-divider>
        </div>
        </md-list-item>
        <md-list-item class="md-inset" v-for="(facility, indexfacility) in integratorFacility.facilities" :key="indexfacility" v-if="integratorFacility.facilities.length > 0" @click="selectfacilityOrChain(facility)">
        <md-icon v-if="!facility.isChainApiKey">fitness_center</md-icon>
        <md-icon v-else>share</md-icon>
        <div class="md-layout">
        <div class="md-layout-item md-size-25 md-medium-size-50 md-small-size-100">
        <span class="md-list-item-text">{{facility.name}}</span></div>
        <div class="md-layout-item md-size-25 md-medium-size-50 md-small-size-100">
        <span class="md-list-item-text">{{facility.url}}</span></div>
        <div class="md-layout-item md-size-30 md-medium-size-50 md-small-size-100">
        <span class="md-list-item-text">{{facility.integrationApiKey}}</span></div>
        <div class="md-layout-item md-size-20 md-medium-size-50 md-small-size-100">
        <span class="md-list-item-text">{{facility.twoLetterISOCountryName}}</span></div>
        <md-divider style="width:100%"></md-divider>
        </div>
        </md-list-item>
        </md-list>
        </md-list-item>
        <md-list-item v-else>
          <md-icon>build</md-icon>
          <span class="md-list-item-text">{{integratorFacility.integratorData.id}} - {{integratorFacility.integratorData.name}}</span>
          <md-badge class="md-primary" :md-content="integratorFacility.facilities.length" /><md-icon></md-icon>
          </md-list-item>
        </md-list>
        </div>
      </div>
      <md-progress-bar md-mode="indeterminate" v-if="loading" />
    </main>
  </navigation-layout>
</template>

<script>
import NavigationLayout from '@/components/layouts/navigation'
import RepositoryService from '@/services/repositoryService'
import Field from '@/components/elements/field'
import NotificationService from '@/services/notificationService'
import MultipleFields from '@/components/elements/multiplefields'
import router from '@/router'
import Utils from '@/utils/utils'

export default {
  name: 'integrated-facilities',
  data: () => ({
    title: 'Integrated facilities',
    abstract: 'All integrated facilities by integrator',
    integrators: [],
    integratedfacilities: [],
    integratorsWithFacilitiesData: [],
    loading: false
  }),
  components: {
    NavigationLayout,
    Field,
    MultipleFields
  },
  created: async function () {
    this.loading = true
    await NotificationService.manageNotification(this, await RepositoryService.getIntegrators(),
      (data) => {
        this.integrators = data.integrators.sort(Utils.orderArrayObjectByFieldNumberAsc('name'))
      })
    await NotificationService.manageNotification(this, await RepositoryService.getFacilitiesWithIntegration({}),
      (data) => {
        this.integratedfacilities = data.sort(Utils.orderArrayObjectByFieldNumberAsc('url'))
      })
    for (var i = 0; i < this.integrators.length; i++) {
      var integratorId = this.integrators[i].id
      this.integratorsWithFacilitiesData.push({integratorData: this.integrators[i], facilities: this.integratedfacilities.filter(function (value) { if (value.integratorId === integratorId) { return value } })})
    }
    this.loading = false
  },
  methods: {
    async selectfacilityOrChain (facilityData) {
      if (!facilityData.isChainApiKey) {
        await NotificationService.manageNotification(this, await RepositoryService.facilityDetails(facilityData.id),
          (data) => {
            RepositoryService.session.setselectedFacility(data)
            router.push({
              name: 'facilitymenu'
            })
          })
      } else {
        await NotificationService.manageNotification(this, await RepositoryService.chainDetails(facilityData.id),
          (data) => {
            RepositoryService.session.setselectedChain(data)
            router.push({
              name: 'chainmenu'
            })
          })
      }
    },
    exportData () {
      let blob = new Blob([this.createCsvData()], {
        type: 'text/csv'
      })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `IntegratedFacilities.csv`
      link.click()
    },
    createCsvData () {
      let csvContent = '"sep=,"\r\nintegrator id,integrator name,facility name,facility url,integration api key,country name,is chain api key\r\n'
      for (var integratorIndex = 0; integratorIndex < this.integratorsWithFacilitiesData.length; integratorIndex++) {
        var facilities = this.integratorsWithFacilitiesData[integratorIndex].facilities
        var integratorData = this.integratorsWithFacilitiesData[integratorIndex].integratorData
        for (var facilityIndex = 0; facilityIndex < facilities.length; facilityIndex++) {
          let row = `${integratorData.id},${integratorData.name},${facilities[facilityIndex].name},${facilities[facilityIndex].url},${facilities[facilityIndex].integrationApiKey},${facilities[facilityIndex].twoLetterISOCountryName},${facilities[facilityIndex].isChainApiKey}`
          csvContent += row + '\r\n'
        }
      }
      return csvContent
    }
  }
}

</script>

<style lang="scss" scoped>
  .md-list {
    width: 320px;
    max-width: 100%;
    display: inline-block;
    vertical-align: top;
    border: 1px solid rgba(#000, .12);
  }
</style>
